import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";

const HUB_URL = `${(process.env.REACT_APP_API_URL || "").replace(/\/$/, "")}/hubs/notifications`;

export function useNotificationHub({ onNotification }) {
  const connRef = useRef(null);

  useEffect(() => {
    if (!onNotification) return;

    const getToken = async () => {
      let token = localStorage.getItem("authorize_api_token") || "";
      if (!token) {
        // Wait up to 3s for the first API call to populate the token
        for (let i = 0; i < 6 && !token; i++) {
          await new Promise((r) => setTimeout(r, 500));
          token = localStorage.getItem("authorize_api_token") || "";
        }
      }
      return token;
    };

    const conn = new signalR.HubConnectionBuilder()
      // the hub authenticates with the token, not cookies: without credentials the browser accepts the
      // API's wildcard CORS header (Prod), which it refuses for a request sent with credentials
      .withUrl(HUB_URL, { accessTokenFactory: getToken, withCredentials: false })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.None)
      .build();

    connRef.current = conn;

    conn.on("notification", onNotification);

    conn.start().catch(() => {
      // Hub unavailable — polling fallback still active in TopBarComponent
    });

    return () => {
      conn.stop();
    };
  }, []);
}
